// extracted by mini-css-extract-plugin
export default {"root":"hobby_root__PyXpD","header":"hobby_header__yLLqe","title":"hobby_title__DM+R9","desc":"hobby_desc__zYL7e"};